import { useEffect, useRef } from 'react'

import type { UiOperationToolCall } from '@/services/uiActions/toolCalls'
import { readUiOperationToolCall } from '@/services/uiActions/toolCalls'
import { MESSAGE_TYPE_TOOL_CALL } from '@constants/agentTypes'

import { useUiActionRunner } from './useUiActionRunner'

export type UiActionToolCallsArgs = {
  messages: readonly UiOperationToolCall[]
}

export function useUiActionToolCalls({ messages }: UiActionToolCallsArgs): void {
  const { submit } = useUiActionRunner()

  const claimed = useRef(new Set<string>())
  const queue = useRef(Promise.resolve())

  useEffect(() => {
    for (const message of messages) {
      const pending = readUiOperationToolCall(message, MESSAGE_TYPE_TOOL_CALL)
      if (!pending || claimed.current.has(pending.source.id)) continue

      claimed.current.add(pending.source.id)
      queue.current = queue.current.then(() => submit(pending.operation, pending.source).then(() => undefined))
    }
  }, [messages, submit])
}
